var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 0C7.17474 0 0 7.17474 0 16C0 24.8253 7.17474 32 16 32C24.8253 32 32 24.8253 32 16C32 7.17474 24.8253 0 16 0ZM25.2968 12.6989L15.0232 22.9726C14.7873 23.2085 14.4842 23.3432 14.1811 23.3432C13.8779 23.3432 13.5749 23.2085 13.3389 22.9726L7.68012 17.3138C7.20855 16.8422 7.20855 16.0675 7.68012 15.596C8.15169 15.1244 8.92638 15.1244 9.39795 15.596L14.1811 20.3791L23.6127 10.9475C24.0843 10.476 24.8589 10.476 25.3305 10.9475C25.7685 11.4525 25.7685 12.2274 25.2969 12.6989H25.2968Z","fill":"#FFD301"}));
}

CheckIcon.defaultProps = {"width":"30","height":"30","viewBox":"0 0 32 32","fill":"none"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
